import { PackageType } from '@frontend/package/types';
import { ScreenType } from '@frontend/wizard/types';

import { useColliConfirmOpenSlotsSerial } from '../../hooks/use-colli-confirm-open-slots-serial';

const useDropOffConfirmOpenSlotsSerial = () =>
    useColliConfirmOpenSlotsSerial({
        screenType: ScreenType.DROP_OFF_CONFIRM_OPEN_SLOTS_SERIAL,
        packageType: PackageType.DROP_OFF
    });

export default useDropOffConfirmOpenSlotsSerial;
